// @todo 是否是有效登录信息
export const isValidUserInfo = (info: any) => info && Object.keys(info).length > 0;
